import { useFormDataQuery } from '@/api/getters';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { OWNER_ACCOUNT_IS_OWNER_NAME } from '@/features/v2/summaryForms/components/CheckboxAccountIsOwner';
import { OWNER_PHONE_NAME } from '@/features/v2/summaryForms/components/InputPhone';
import { validateEmail } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';
interface ErrorOwnerFields {
  phone?: string;
  email?: string;
}

export const OWNER_EMAIL_NAME = 'owner.email';

const InputEmail = ({
  name = OWNER_EMAIL_NAME,
  focused,
  index,
  setFocused,
  className = 'col-span-4 md:col-span-2',
  autoCompleteOff = false,
  disabled = false,
}: {
  name: string;
  focused: string;
  index?: number;
  setFocused: (value: string) => void;
  className?: string;
  autoCompleteOff?: boolean;
  disabled?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger } = useFormContext();
  const { watch, formState } = useFormContext();
  const { data } = useFormDataQuery();

  const emailFieldName =
    name === OWNER_EMAIL_NAME ? OWNER_PHONE_NAME : `coowners.${index}.phone`;

  const otherMails =
    name === OWNER_EMAIL_NAME
      ? []
      : [watch(`coowners.${(index ?? 0) - 1}.email`), watch(OWNER_EMAIL_NAME)];

  const isAccountOwner =
    !!watch(OWNER_ACCOUNT_IS_OWNER_NAME) && name === OWNER_EMAIL_NAME;

  const isPhoneAdded = watch(emailFieldName);

  const phoneFieldError =
    name === OWNER_EMAIL_NAME
      ? (formState.errors.owner as ErrorOwnerFields)?.phone
      : (formState.errors.coowners as unknown as ErrorOwnerFields[])?.[
          index ?? 0
        ]?.phone;

  return (
    <FormField
      name={name}
      rules={{
        validate: (value: string) =>
          validateEmail({
            value,
            otherMails,
            accountEmail: isAccountOwner ? null : data?.user?.email,
            isOptional: !isPhoneAdded,
          }),
      }}
      defaultValue={isAccountOwner ? data?.user?.email : ''}
      render={({ field, fieldState }) => {
        const { value, onChange, onBlur, ...restField } = field;
        return (
          <FormItem className={className}>
            <FormControl>
              <Input
                autoComplete={autoCompleteOff ? 'none' : 'email'}
                label={i18n.t('Adres e-mail')}
                value={value === null ? '' : value}
                error={fieldState.error?.message}
                disabled={disabled}
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onChange={(e) => {
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  setFocused('');
                  phoneFieldError && trigger(emailFieldName);
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputEmail;
